/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import Header from "./Classes/Header";
import Toggler from "./Classes/Toggler";
import LinkHandler from "./Classes/LinkHandler";

import Accordion from './Classes/Accordion';
import EqualHeight from './Classes/EqualHeight';
import MobileHeaderHeight from './Classes/MobileHeaderHeight';
import CurrencyDecimalReplacer from './Classes/CurrencyDecimalReplacer';

var focusHandlerInstance = null;
var lazyLoadInstance = null;
var downloaderInstance = null;
var headerInstance = null;
var togglerInstance = null;

var accordionInstance = null;
var equalHeightInstance = null;
var mobileHeaderHeightInstance = null;
var jumpInstance = null;
var youtubeLinksInstance = null;
var currencyDecimalReplacerInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  focusHandlerInstance = new FocusHandler();

  new LinkHandler();

  lazyLoadInstance = new LazyLoad();

  headerInstance = new Header({
    mobileNavToggleSelector: '.js-toggle-main-menu',
    mainMenuContainerSelector: '.header__menu',
    submenuToggleSelector: '.js-nav-dropdown-toggler',
    submenuBackToggleSelector: '.js-menu-item-back',
    searchOpenSelector: '.js-search-trigger',
    searchCloseSelector: '.js-search-close',
  });

  togglerInstance = new Toggler({
    togglerButtonSelector: '.ns-portrait__readmore-toggle',
    togglerContainerSelector: '.ns-portait__readmore-content'
  });


  new ResponsiveTablesLight({
    tableComponentSelector: '.ns-table-wrap',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.ns-table-wrap table'
  });

  /*downloaderInstance = new XDownloader({
    downloadText: "Download Excel", //Can be empty if you want to use an icon instead
    backgroundColor: "6ab04c", //Colored Cells Background
    backgroundClass: 'ns-backgroundcolor-gf_3a-green', //Class of colored cells
    borderColor: '95afc0', //Color of border
    borderStyle: 'thin', // thin/dotted/medium/double/thick
    headClass: 'head', //Class you want your columns based on. Will be bold in Excel
    boldClass: 'title', //Class for Bold text in Excel
    borderClass: 'ns-borderbottom-line_dots'
  });*/

  accordionInstance = new Accordion({
    accordions: '.js-accordion-toggle'
  });

  equalHeightInstance = new EqualHeight({
    elementSelector: '.ns-portrait__content'
  })

  mobileHeaderHeightInstance = new MobileHeaderHeight({
    headerSelector: '.header__inner'
  });

  currencyDecimalReplacerInstance = new CurrencyDecimalReplacer({
    currencySelectors: 'span.cur, span.curb'
  });

  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });

});
